import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./features/auth/authSlice";
import newBuilderReducer from "./features/dashboard/newBuilderSlice";

import collapseReducer from "./features/Sidebar/collapseSlice";
import uiReducer from "./features/ui/uiSlice";
import profileReducer from "./features/profile/profileSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: newBuilderReducer,
    collapse: collapseReducer,
    profile: profileReducer,
    ui: uiReducer,
  },
});
